import { render, staticRenderFns } from "./allListRegion.vue?vue&type=template&id=75265100&scoped=true"
import script from "./allListRegion.vue?vue&type=script&lang=js"
export * from "./allListRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75265100",
  null
  
)

export default component.exports